<!-- listBoxInput.vue -->

<template>
  <div>
    <div class="form-floating">
        <input 
            v-model="searchText"
            :class="['form-control', formData.fields[fieldName].class]"
            @input="(!searchIn.alwaysList) ? searchList() : null"
            @blur="leaveFromInput"
            @focus="inToInput"
            :id="formData.fields[fieldName].id"
            :required="formData.fields[fieldName].required"
            autocomplete="off"
            :placeholder="['Escribe una ', formData.fields[fieldName].label]"
        />
        <label :for="formData.fields[fieldName].id">{{ formData.fields[fieldName].label }}</label>
    </div>
   <ul @mouseenter="overList" @mouseleave="leaveList" v-if="showListToSelect" class="list-group shadow-lg mt-2">
        <li 
            v-for="regList in matchingValues"
            :key="regList.id_"
            @click="selectregList(regList)"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            >
            <span>{{ regList[searchIn.field] }}</span>
            <span v-if="searchIn.show" class="owl360_badge bg-primary rounded-pill">{{ regList[searchIn.show] }}</span>
        </li>
    </ul>

  </div>
</template>

<script>
export default {
    props: {
        fieldData: {
            type: Object,
            required: true
        },
        formData: {
            type: Object,
            required: true
        },
        fieldName: {
            type: String,
            required: true
        }
    },
  watch: {
    fieldData(newVal) {
        this.searchText = newVal;
    }
  },
  computed: {
        fieldValue() {
            return this.fieldData;
        },
        showListToSelect() {
            return this.showList;
        }
   },
  data() {
    return {
      searchText: this.fieldData || '',
      matchingValues: [],
      searchIn : this.formData.fields[this.fieldName].component,
      showList: false,
      swOverList: false,
      lastSearch : ""
    };
  },
  methods: {
    async searchList() {

       if (this.formData.fields[this.fieldName].alwaysList) return;
       if (this.searchText.length < 3  ) return ;

       this.searchText = this.checkCase(this.searchText);
       if (this.searchText == this.lastSearch ) return ;

       this.searchListFrom();
    },
    async overList() {
        this.swOverList=true;
    },
    async leaveList() {
        this.swOverList=false;
    },
      inToInput() {
        if (!this.searchTex) this.searchTex = "";
        if (this.searchIn.alwaysList && this.matchingValues.length==0) {
            this.searchListFrom();
            return
        }
        if (this.searchText.length < 3 ) return;

        if (this.searchText.length >= 3 && this.lastSearch != this.searchText )  this.searchListFrom();
        if (this.searchText.length >= 3 && this.lastSearch == this.searchText && this.matchingValues.length > 0 ) this.showList=true;
    },
    async leaveFromInput() {
        if (! this.swOverList) {
            this.showList=false;
            if (this.searchText != this.fieldData) this.searchText= (this.fieldData) ? this.fieldData : "";
        }
    },
    async searchListFrom() {
       if (this.matchingValues.length>0 && this.searchIn.alwaysList) {this.showList = true ; return; }
       if (this.searchIn.from === "FS")  this.matchingValues = await this.getFirestore(this.searchIn);
       else  if (this.searchIn.from.toLowerCase() === "api") this.matchingValues = await this.getFromApi(this.searchIn);
       else this.matchingValues = (this.searchIn.options) ? this.searchIn.options : [];
       if (this.matchingValues.length>0) this.showList = true;
       else this.showList=false;
    },
    async getFirestore(searchIn) {
        let query = this.$Genv.fsCia.collection(searchIn.collection)
        if (this.searchText.length > 0 && !this.searchIn.alwaysList) {
            query = query.where(searchIn.field, ">=", this.searchText).where(searchIn.field, "<=", this.searchText + "\uf8ff")
            this.lastSearch = this.searchText;
        }
        const dataCol = await query.get(true);
        return this.prepareListToSelect(dataCol, searchIn);
      },
    async getFromApi(searchIn) {
        const st = await this.$ajax(searchIn.action || searchIn.collection,this.searchText,"term" )
        console.log("getFromApi:"+searchIn.action, st)
        return this.prepareListToSelect(st.data, searchIn);
    },
    prepareListToSelect(dataCol, searchIn) {
        const isVarFields = /{{[\w\-_]+}}/.test(searchIn.key);
        const vars = (isVarFields) ? this.$arMatchs(searchIn.key) : false;
        //console.log("Col:"+searchIn.collection+" field:"+searchIn.field+" search:"+this.searchText+" l:"+this.searchText.length," data:",dataCol)
       
        const data = ((j,C) => {
                for (let c in C ) {
                    const key = (isVarFields ) ? this.getKey(vars,C[c],searchIn.key) : C[c][searchIn.key];
                    j[key]=C[c];
                } 
                return j
            })({},dataCol)
        return ((j,C) => {for (let c in C) j.push(C[c]); return j})([],data) ;
    },

    getKey(vars,data,key) {
       let strKey=key;
       // eslint-disable-next-line no-useless-escape
       for (let v in vars) strKey = strKey.replace(new RegExp("\{\{"+vars[v]+"\}\}","gm"),data[vars[v]])
        return strKey;
    },
    selectregList(regList) {
        this.showList=false;

        if (!this.searchIn.set) this.searchIn.set = {[this.fieldName]: this.searchIn.field}
        if (!this.searchIn.set[this.fieldName]) this.searchIn.set[this.fieldName] =  this.searchIn.field;
        const json = {...this.searchIn.set}

        for (const f in json) json[f] =  regList[json[f]] || null ;

        this.$emit('input-change', json);
        return;
      //this.matchingValues = [];
    },

    checkCase(inputValue) {
        const currentClass = this.formData.fields[this.fieldName].class;

        if (currentClass.includes('uppercase')) {
            inputValue = inputValue.toUpperCase();
        } else if (currentClass.includes('downcase')) {
            inputValue = inputValue.toLowerCase();
        }

        return inputValue;
    }
  }
};
</script>

<style scoped>
.uppercase { text-transform: uppercase; }
.lowercase { text-transform: lowercase; }
.capitalize {text-transform: capitalize; }
</style>
